import { useEffect } from "react";

/**
 * A hook that runs one time only after render
 */
const useMount = (callback, cleanupFunction) => {
  useEffect(() => {
    callback();

    if (cleanupFunction) {
      return cleanupFunction;
    }
    //eslint-disable-next-line
  }, []);
};

export default useMount;
